import gql from 'graphql-tag';

import type { BrandBrief } from 'src/data/brief';
import { executeGqlQuery } from 'src/graphql/client';
import type { ID } from 'src/lib/collection';
import { getSingleProp, throwIfResultHasErrors } from 'src/lib/graphql';

import { FRAGMENT_BRAND_BRIEF } from './schema';

const QUERY = gql`
  query BrandBriefs($brandVoiceId: ID!) {
    brandBriefs(brandVoiceId: $brandVoiceId) {
      ...BrandBrief
    }
  }
  ${FRAGMENT_BRAND_BRIEF}
`;

export const queryBrandBriefs = async (brandVoiceId: ID): Promise<BrandBrief[] | undefined> => {
  const variables = { brandVoiceId };

  const result = await executeGqlQuery({
    query: QUERY,
    variables,
  });
  throwIfResultHasErrors(result);

  return getSingleProp<BrandBrief[]>(result.data);
};
